module.exports = __webpack_public_path__ + "img/i_blog.83f9bf5c.svg";